import React, { useContext, useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Context } from "../../../_context/Store";
import LoginForm from "./Forms/LoginForm";
import { ResetPassword } from "./views/ForgotPassword/ResetPassword";
import {
  getFingerPrint,
  isErrorCodeExist,
  keyGenerationFun,
  showCustomLoading,
} from "../../../_helpers/support.services";
import { Container, Grid } from "@mui/material";

import {
  responseCodes,
  authConstants,
  contextApiActions,
  dashboardConstants,
} from "../../../_redux/_constants";
import {
  otpConfirmRequest,
  otpResendRequest,
  hideCustomeError,
  authReducerInitiate,
  hideConfirmServerError,
  hideError,
  CSRFTokenGenRequest,
  dashboardBannerListRequest,
} from "../../../_redux/_actions";
import { LoginSlider } from "../../_uiComponents/LoginPage/LoginSlider";
import { UiLanguageSelect } from "../../_uiComponents/UiLanguageSelect";
import { OtpConfirmModal } from "./views/OtpConfirmModal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UiLoginLoader } from "../../_uiComponents/common/UiLoginLoader";

const Login = (props) => {
  const { i18n } = useTranslation();
  const [state, dispatch] = useContext(Context);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [febaToWebOtpResendStatus, setFebaToWebOtpResendStatus] = useState({
    emailOtpEnabled: false,
    smsOtpEnabled: false,
  });

  const navigate = useNavigate();
  const [otpResendRequestType, setOtpResendRequestType] = useState(false);
  const handleAltLinkDrawerToggle = () => {
    state.ui_login_alt_link_drawer
      ? dispatch({ type: "LOGIN_ALT_LINK_DRAWER_TOGGLE", payload: false })
      : dispatch({ type: "LOGIN_ALT_LINK_DRAWER_TOGGLE", payload: true });
  };

  const actionDispatch = useDispatch();

  const {
    customErrors,
    userDetails,
    loader,
    auth,
    keyGeneration,
    isAdminPasswordResetRequired,
    loginOtpTimer,
    multiTabOpen,
    loginWebBannersList,
  } = useSelector((state) => {
    return {
      customErrors: state.errorMessage?.customErrors,
      loginOtpTimer: state.auth?.loginOtpTimer,
      userDetails: state.auth?.userDetails,
      loader: state.loading,
      auth: state.auth,
      keyGeneration: state.keyGeneration,
      isAdminPasswordResetRequired: state.auth?.isAdminPasswordResetRequired,
      multiTabOpen: state.auth?.multiTabOpen,
      loginWebBannersList: state.dashboard?.loginWebBannersList,
    };
  });

  const localStorageClear = async () => {
    localStorage.removeItem("fingerPrint");
    localStorage.removeItem("publicKey");
  };

  useEffect(() => {
    const initializeLogin = async () => {
      await localStorageClear();
      actionDispatch(authReducerInitiate());
      actionDispatch(CSRFTokenGenRequest());
    };

    initializeLogin();
  }, []);

  useEffect(() => {
    if (!auth?.isTokenGen) {
      return;
    }

    actionDispatch(
      dashboardBannerListRequest({
        locale: i18n.language || "en",
        bannerType: dashboardConstants.BANNER_TYPE_LOGIN_WEB,
      }),
    );
  }, [auth?.isTokenGen, i18n.language]);

  //==================key generation====================

  useEffect(() => {
    const generateKeyIfTokenGen = async () => {
      if (auth?.isTokenGen) {
        try {
          await keyGenerationFun(actionDispatch);
        } catch (error) {
          console.error("Error during key generation:", error);
        }
      }
    };
    generateKeyIfTokenGen();
  }, [auth?.isTokenGen]);

  //==================end key generation====================

  const closeOtpModal = () => {
    // Close OTP modal and clear related login OTP errors
    setOtpResendRequestType(false);
    actionDispatch(
      hideCustomeError([
        responseCodes.AUTH_ERROR_OTP_CONFIRM,
        responseCodes.AUTH_ERROR_OTP_CONFIRM_INCORRECT,
        responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_DL_TO_WEB,
        responseCodes.OTP_REQUEST_LIMIT_REACHED,
      ]),
    );
  };

  const otpConfirm = (values) => {
    if (auth?.customerOnboardingWithLogin?.febaToWebOtpRequested) {
    } else {
      actionDispatch(
        otpConfirmRequest({
          ...values,
        }),
      );
    }
  };

  useEffect(() => {
    if (isAdminPasswordResetRequired) {
      setShowPasswordReset(true);
      navigate("/reset-password");
    }
  }, [isAdminPasswordResetRequired]);

  const otpResend = (sendType) => {
    setOtpResendRequestType(true);
    actionDispatch(otpResendRequest({ sendType: sendType }));
  };

  const otpSendRequest = (values) => {
    setFebaToWebOtpResendStatus({
      ...values,
    });
  };

  const confirmOk = () => {
    actionDispatch(hideError());
    props.history.push("/onboarding-password");
  };

  const confirmCancel = () => {
    actionDispatch(authReducerInitiate());
    actionDispatch(hideConfirmServerError());

    dispatch({
      type: contextApiActions.UI_CONFIRMATION_TOGGEL,
      payload: { visibility: false, buttonRightFunction: null },
    });
  };

  useEffect(
    function () {
      if (customErrors?.length > 0) {
        customErrors.some(
          (el) =>
            el.statusCode ==
            responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_CUSTOMER_NOT_REGISTERED_WITH_WEB,
        ) &&
          // dispatch({
          //     type: contextApiActions.UI_CONFIRMATION_TOGGEL,
          //     payload: {
          //         visibility: true,
          //         icon: AlreadyAMobileBankUserIcon,
          //         buttonConfirmLeft: "Close",
          //         variantButtonLeft: "outline-primary",
          //         buttonConfirmRight: "Register",

          //         header: "Hello!",
          //         paragraph: (
          //             <p>
          //                 You are already a mobile banking user.
          //                 Please click on "Register" to get signed up for
          //                 Online Banking.
          //             </p>
          //         ),

          //         buttonRightFunction: confirmOk,
          //         buttonLeftFunction: confirmCancel,
          //     },
          // });

          customErrors.some(
            (el) =>
              el.statusCode ==
              responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_FEBA_TO_WEB_MIGRATION_STATUS_EXPIRED,
          ) &&
          dispatch({
            type: contextApiActions.UI_CONFIRMATION_TOGGEL,
            payload: {
              visibility: true,
              // icon: UiDeactivatedAccountSvg,
              buttonConfirmLeft: "Not Now",
              variantButtonLeft: "outline-primary",
              buttonConfirmRight: "Register",

              header: "Uh oh!",
              paragraph: (
                <Fragment>
                  <p>
                    This account has been deactivated due to inactivity, but we
                    would love to welcome you back! Click 'Register' to create
                    your account. <br /> Once you have registered successfully
                    all your previously saved billers & beneficiaries will be
                    restored.
                  </p>
                  <br />
                </Fragment>
              ),

              buttonRightFunction: confirmOk,
              buttonLeftFunction: confirmCancel,
            },
          });
      }
    },
    [customErrors],
  );

  return (
    <div className="df-login-page df-login-page-scrollable">
      {showCustomLoading(
        [
          authConstants.CSRF_TOKEN_GEN_REQUEST,
          authConstants.KEY_GENERATION_REQUEST,
        ],
        loader?.pendingRequests,
      ) && <UiLoginLoader />}
      {/* <UiLoginLoader /> */}

      <div className="df-login-background">
        <LoginSlider loginWebBannersList={loginWebBannersList} />
      </div>
      <div className="df-login-content">
        <div className="df-login-form-wrapper">
          <LoginForm {...props} />
        </div>
      </div>

      {/* <Container maxWidth="lg">
        <Grid container className="df-align-center">
          <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
            <LoginSlider />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
            <LoginForm {...props} />
          </Grid>
        </Grid>
      </Container> */}

      <OtpConfirmModal
        show={
          otpResendRequestType ||
          isErrorCodeExist(
            [responseCodes.AUTH_ERROR_OTP_CONFIRM],
            customErrors,
          ) ||
          auth?.customerOnboardingWithLogin?.febaToWebOtpRequested ||
          isErrorCodeExist(
            [responseCodes.OTP_REQUEST_LIMIT_REACHED],
            customErrors,
          )
        }
        userDetails={userDetails?.customer || userDetails}
        otpConfirmRequest={otpConfirm}
        otpResendRequest={otpResend}
        closeModal={closeOtpModal}
        countDownTimer={loginOtpTimer}
      />
    </div>
  );
};

export default Login;
